<span class="icc-chip-wrapper"><span class="content"><ng-content></ng-content></span></span>
<span class="icc-chip-focus-overlay"></span>